import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { TagsServiceProvider } from '../../api/tags'

const TagsService = TagsServiceProvider()
const name = 'addTag'

export default (data) => (asyncAction(
  name,
  TagsService.addTag,
  data
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/tags/addTag.js